import { Component, HostListener } from '@angular/core';
import { SidebarItemComponent } from './sidebar-item/sidebar-item.component';
import { LanguagesMenuComponent } from '../header/languages-menu/languages-menu.component';
import {MatSidenavModule} from '@angular/material/sidenav';
import { LOCAL_STORAGE_KEYS } from '../../constants';
import { TranslatorService } from '../../services/translator_service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiStore } from '../../web-services/api/api.store';
import { ApiQuery } from '../../web-services/api/api.query';
import { ResponsiveService } from '../../services/responsive.service';
import { transition, trigger } from "@angular/animations";
import { environment } from '../../../environments/environment';
import { LogoutValidationComponent } from './logout-validation/logout-validation.component';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [SidebarItemComponent,LanguagesMenuComponent,MatSidenavModule,TranslateModule,CommonModule,RTLDivDirectiveDirective],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  animations: [
		trigger("sideMenu", [
		  transition(":enter", []),
		  transition(":leave", [])
		])
	]
})
export class SidebarComponent{
  	isMobile: boolean = false;
	isOpen = false;
	usageType = 1;
	version_number: String;
	translationsObj:any;
	currnetLang:any;
	userInfo:any;
	user_role_id = 0;
	profileMenuOpen = false;

	@HostListener('document:click')
	onDocumentClick() {
		this.profileMenuOpen = false;
	}

	constructor(
		private translator: TranslatorService,
		private dialog: MatDialog,
		private router: Router,
		private apiStore:ApiStore,
		private apiQuery: ApiQuery,
		private responsiveService: ResponsiveService
	) {
		this.translator.currentLangEmitter$
		.subscribe(async value=>{			      			
			this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			this.currnetLang = value;
		})

		this.version_number = environment.appVersion;
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.apiQuery.user$.subscribe((user:any) => {
			if (!user) return;
			this.userInfo = user;
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
			this.user_role_id = user["user_role_id"];
		});
	}

	onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	  }

	toggleProfileMenu() {
		this.profileMenuOpen = !this.profileMenuOpen;
	}

	navigateToBilling() {
		this.profileMenuOpen = false;
		this.router.navigate(['/billing']);
	}

	onReqToLogOut() {
		this.profileMenuOpen = false;
		const isNewInstallationWizard = this.router.url.includes('newinstallationwizard');
		
		if (!isNewInstallationWizard) {
			this.logout();
			return;
		}

		this.dialog.open(LogoutValidationComponent, {
			width: '600px',
			disableClose: true
		}).afterClosed().subscribe(result => {
			if (result) {
				this.logout();
			}
		});
	}

	logout() {
		// Close all open modals
		this.dialog.closeAll();
		
		this.apiStore.update({
			// Bin status component
			allFilteredDailyWorkPlan: [],
			filteredDailyWorkPlan: [],
			
			// Active bins component
			allFilteredBasicBins: [],
			filteredBasicBins: [],
			
			// Collection components
			allCollectionsKpis: [],
			collectionsKpis: [],
			collectionsStatsInCollections: [],
			allCollectionsStats: [],
			
			// Refill components
			allRefillsKpis: [],
			refillsKpis: [],
			allRefillsStats: [],
			refillsStats: [],
			
			// Other components
			userEventsByType: [],
			filteredBins: [],
			collectionVolume: [],
			exceptionsReports: [],
			allDailyWorkPlanCalanderData: [],
			dailyWorkPlanCalanderData: [],
			allWorkPlanScheduler: [],
			workPlanScheduler: [],
			allSitesListData: [],
			sitesListData: []
		});

		// Clear all session storage items at once
		const sessionKeys = [
			'fillingsMinDate', 'fillingsMaxDate', 'fillingsStartDate', 'fillingsEndDate',
			'collectionsMinDate', 'collectionsMaxDate', 'collectionsStartDate', 'collectionsEndDate',
			'reportsMinDate', 'reportsMaxDate', 'reportsStartDate', 'reportsEndDate',
			'ticketManagementMinDate', 'ticketManagementMaxDate', 'ticketManagementStartDate', 'ticketManagementEndDate',
			'insightsMinDate', 'insightsMaxDate', 'insightsStartDate', 'insightsEndDate',
			'blackStatusBin'
		];
		sessionKeys.forEach(key => sessionStorage.removeItem(key));

		// Clear local storage items
		localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN);
		localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
		localStorage.removeItem('language');

		// Navigate to login
		this.router.navigate(['/login']);
	}
}
